/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FindingTypeGroup = {
    SbomRelated: 'SBOM_RELATED',
    DocumentAnalysis: 'DOCUMENT_ANALYSIS',
    Manual: 'MANUAL'
} as const;
export type FindingTypeGroup = typeof FindingTypeGroup[keyof typeof FindingTypeGroup];

